import "../Leaderboard.css";
import "../../globals/global.css";
import NavigationBar from "./../../../../components/navbar/NavigationBar";
import PageTitle from "../../../../components/Page Title/PageTitle";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import ge from "../../../../assets/photos/ge.png";
import us from "../../../../assets/photos/us.png";
import sov from "../../../../assets/photos/sov.png";
import inf from "../../../../assets/photos/inf.png";
import tanker from "../../../../assets/photos/tank.png";
import pilot from "../../../../assets/photos/pilot.png";
import para from "../../../../assets/photos/para.png";
import recon from "../../../../assets/photos/recon.png";
const leaderboardsname = { "Battles Won (Assault Team)": "StrategicBattlesWon", "Battle Participation (Assault Team)": "StrategicParticipation" };
const subcategories = ["Battles Won (Assault Team)", "Battle Participation (Assault Team)"];
const leaderboardDescriptions = {
  "Battles Won (Assault Team)": "To be written",
  "Battle Participation (Assault Team)": "To be written",
};

const LeaderboardAssaultTeam = () => {
  const soldiericons = [inf, inf, pilot, pilot, para, tanker, recon];
  const images = [ge, ge, us, sov];

  const [selectedsubcategory, selectSubcategory] = useState(subcategories[0]);

  const navigate = useNavigate();
  const [leaderboardData, setleaderboardData] = useState({ rankings: [] });
  useEffect(() => {
    fetch("https://www.hng-group.com/hng6060/fetch_leaderboard?duration=Month&rows=50&leaderboard=" + leaderboardsname[selectedsubcategory])
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setleaderboardData(data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }, [selectedsubcategory]);

  return (
    <div className="pagebackground">
      <NavigationBar />
      <PageTitle title={"Leaderboard: Assault Teams"} />
      <div className="pagebox-leaderboards">
        <div className="backtoleaderboards" onClick={() => navigate("/leaderboard")}>
          Go back to leaderboard list
        </div>
        <div className="leaderboardcategoriesgrid">
          {subcategories.map((val) => (
            <div onClick={() => selectSubcategory(val)} className={selectedsubcategory === val ? "leaderboardgriditemSelected" : "leaderboardgriditem"}>
              {val}
            </div>
          ))}
        </div>
        <div className="leaderboarddiv">
          <div className="leaderboardDescriptionTitle">{selectedsubcategory}</div>
          <div className="leaderboardDescriptionText">{leaderboardDescriptions[selectedsubcategory]}</div>
          <div className="leaderboardcolumnTitlebar">
            <div className="leaderboardcolumnTitlebarItem">Rank</div>
            <div className="leaderboardcolumnTitlebarItem">Value</div>
            <div className="leaderboardcolumnTitlebarItem">Faction</div>
            <div className="leaderboardcolumnTitlebarItem">Assault Team</div>
            <div className="leaderboardcolumnTitlebarItemLonger">Assault Team Name</div>
            <div className="leaderboardcolumnTitlebarItemLonger">Player</div>
          </div>
          {leaderboardData["rankings"].map((val, idx) => {
            return (
              <div key={idx} className={idx % 2 === 1 ? "leaderboardRowOdd" : "leaderboardRowEven"}>
                {idx + 1 === 1 ? (
                  <div className="LeaderboardRowTop3">
                    <div className="LeaderboardRowGold"></div>
                    <div className="LeaderboardRowItemShort">{idx + 1}</div>
                  </div>
                ) : idx + 1 === 2 ? (
                  <div className="LeaderboardRowTop3">
                    <div className="LeaderboardRowSilver"></div>
                    <div className="LeaderboardRowItemShort">{idx + 1}</div>
                  </div>
                ) : idx + 1 === 3 ? (
                  <div className="LeaderboardRowTop3">
                    <div className="LeaderboardRowBronze"></div>
                    <div className="LeaderboardRowItemShort">{idx + 1}</div>
                  </div>
                ) : (
                  <div className="LeaderboardRowItem">{idx + 1}</div>
                )}
                <div className="LeaderboardRowItem">{val["value"]}</div>
                <div className="LeaderboardRowItem">
                  <img src={images[val["factiontemplateid"]]} className="leaderboardRowPicture"></img>
                </div>
                <div className="LeaderboardRowItem">
                  <img src={soldiericons[val["SoldierClass"]]} className="leaderboardRowPicture"></img>
                </div>

                <div className="LeaderboardRowItemLonger">{val["name"]}</div>
                <div className="LeaderboardRowItemLonger">{val["gamertag"]}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default LeaderboardAssaultTeam;
